import { DEFAULT_LANG_OBJ } from "@stadium/services/weglot/constants";

/** Case-insensitive check against project language keys. */
export const isLangSupported = (lang, availableLanguages = []) => {
  if (!lang || typeof lang !== "string") return false;
  const normalized = lang.toLowerCase();
  return availableLanguages.some(({ key }) => key?.toLowerCase() === normalized);
};

/** Stable string for effect deps — avoids re-running when array reference changes. */
export const getLanguageListKey = (availableLanguages = []) =>
  availableLanguages.map(({ key }) => key).join("|");

/**
 * Build dropdown language list from Weglot SDK options.
 * English is always first; disabled/deleted entries are excluded.
 */
export const buildWeglotLanguageList = (config, { getLanguageName } = {}) => {
  if (!config || config.deleted_at) {
    return [DEFAULT_LANG_OBJ];
  }

  const resolveLabel = (languageTo, customLocalName, customName) =>
    customLocalName || customName || getLanguageName?.(languageTo) || languageTo;

  const targetLanguages =
    config.languages
      ?.filter(({ enabled, deleted_at }) => enabled && !deleted_at)
      ?.map(({ custom_code, language_to, custom_local_name, custom_name }) => ({
        key: custom_code || language_to,
        label: resolveLabel(language_to, custom_local_name, custom_name),
      }))
      ?.filter(({ key }) => Boolean(key)) || [];

  const languageFrom = config.language_from;
  const withSourceLang =
    languageFrom && !isLangSupported(languageFrom, targetLanguages)
      ? [
          ...targetLanguages,
          {
            key: languageFrom,
            label: resolveLabel(languageFrom, null, null),
          },
        ]
      : targetLanguages;

  const withoutEnglish = withSourceLang.filter(
    ({ key }) => key?.toLowerCase() !== DEFAULT_LANG_OBJ.key,
  );

  return [DEFAULT_LANG_OBJ, ...withoutEnglish];
};
